"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _ = require("../..");
var _utils = require("../../../utils");
var _MessageList = _interopRequireDefault(require("./MessageList"));
var _MessageInput = _interopRequireDefault(require("./MessageInput"));
var _SuggestionList = _interopRequireDefault(require("./SuggestionList"));
var _YouAreBannedNotification = _interopRequireDefault(require("./YouAreBannedNotification"));
var _JoinChannel = _interopRequireDefault(require("./JoinChannel"));
var _CustomAvatar = require("./CustomAvatar");
var _MessageInputInner = _interopRequireDefault(require("./MessageInputInner"));
var _TeamMessageEditForm = _interopRequireDefault(require("./TeamMessageEditForm"));
var _MessageSystem = _interopRequireDefault(require("./MessageSystem"));
var _DateSeparator2 = _interopRequireDefault(require("./DateSeparator"));
var _utils2 = require("../utils");
var _constants = require("../../../utils/constants");
var _Message = _interopRequireDefault(require("./Message"));
var _ReactionSelector = _interopRequireDefault(require("./ReactionSelector"));
var _ReactionsList = _interopRequireDefault(require("./ReactionsList"));
var _excluded = ["channel", "onBack", "ChannelHeader", "client", "globalBan", "joinChat", "joiningChat"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Channel = function Channel(_ref) {
  var _channel$data;
  var propChannel = _ref.channel,
    onBack = _ref.onBack,
    ChannelHeader = _ref.ChannelHeader,
    client = _ref.client,
    globalBan = _ref.globalBan,
    _joinChat = _ref.joinChat,
    joiningChat = _ref.joiningChat,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_streamChatReact.ChatContext),
    contextChannel = _useContext.channel;
  var _useCustomChatContext = (0, _utils2.useCustomChatContext)(),
    publicChatsBan = _useCustomChatContext.publicChatsBan;
  var channel = propChannel || contextChannel;
  // Separate public chats ban on application level
  var bannedInPublicChannels = publicChatsBan.banned,
    publicChatBanExpiresAt = publicChatsBan.banExpiresAt,
    refetchBanStatus = publicChatsBan.refresh;
  // Per-channel ban, can be tracked by checking channel.state.membership but it is not updated while user is online
  // so need to track it on our own
  var _useChannelsBan = (0, _utils2.useChannelsBan)({
      client: client
    }),
    channelsBan = _useChannelsBan.ban;
  var channelId = channel === null || channel === void 0 ? void 0 : channel.id;
  var channelBan = channelsBan[channelId];
  (0, _react.useEffect)(function () {
    if (channel) {
      channel.markRead();
    }
  }, [channel]);
  (0, _react.useEffect)(function () {
    if (channelId) {
      refetchBanStatus();
    }
  }, [channelId]);
  if (!channel) {
    return null;
  }
  var _ref2 = (channel === null || channel === void 0 ? void 0 : channel.state) || {},
    membership = _ref2.membership;
  var isMember = !(0, _lodash.isEmpty)(membership);
  var isAdmin = client.user.role === 'admin';
  var isPostingForbidden = _utils.USER_POSTS_FORBIDDEN_CHAT_CHANNEL_TYPES.includes(channel === null || channel === void 0 ? void 0 : channel.type);
  var isBannedInGetStream = !!channelBan || !!globalBan;
  var hasAnyTypeOfBan = isBannedInGetStream || bannedInPublicChannels;
  var isMessageInputDisplayed = isAdmin || isMember && !hasAnyTypeOfBan && !isPostingForbidden;
  var isNotInCommunityChannel = !isMember && !isAdmin;
  var isFrozen = channel === null || channel === void 0 ? void 0 : (_channel$data = channel.data) === null || _channel$data === void 0 ? void 0 : _channel$data.frozen;
  var publicChatBan = bannedInPublicChannels ? {
    expiration: publicChatBanExpiresAt
  } : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('str-chat__wrapper', {
      'str-chat__wrapper--user-banned': hasAnyTypeOfBan
    }, {
      'str-chat__wrapper--user-not-joined': isNotInCommunityChannel
    }, {
      'str-chat__wrapper--channel-frozen': isFrozen
    })
  }, /*#__PURE__*/_react.default.createElement(_streamChatReact.Channel, _extends({
    channel: channel,
    LoadingIndicator: function LoadingIndicator() {
      return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
    },
    Avatar: _CustomAvatar.CustomAvatar,
    Input: _MessageInputInner.default,
    EditMessageInput: _TeamMessageEditForm.default,
    MessageSystem: _MessageSystem.default,
    AutocompleteSuggestionList: function AutocompleteSuggestionList(props) {
      return /*#__PURE__*/_react.default.createElement(_SuggestionList.default, _extends({
        channel: channel
      }, props));
    },
    doSendMessageRequest: function doSendMessageRequest(cid, messageData) {
      channel.sendMessage(_objectSpread(_objectSpread({}, messageData), {}, {
        mentioned_users: (0, _lodash.filter)(messageData.mentioned_users, function (userId) {
          return userId !== _constants.FAKE_HERE_USER_NAME;
        })
      }));
    },
    DateSeparator: function DateSeparator(props) {
      return /*#__PURE__*/_react.default.createElement(_DateSeparator2.default, _extends({}, props, {
        formatTitleDate: _utils2.formatChatSeparatorDateTitle
      }));
    },
    MessageTimestamp: function MessageTimestamp(props) {
      return /*#__PURE__*/_react.default.createElement(_streamChatReact.MessageTimestamp, _extends({}, props, {
        format: "MMM D, h:mmA"
      }));
    },
    ReactionSelector: _ReactionSelector.default,
    ReactionsList: _ReactionsList.default
  }, props), /*#__PURE__*/_react.default.createElement(_streamChatReact.Window, null, ChannelHeader && /*#__PURE__*/_react.default.createElement(ChannelHeader, {
    channel: channel,
    onBack: onBack
  }), /*#__PURE__*/_react.default.createElement(_MessageList.default, {
    client: client
  }), isMessageInputDisplayed && /*#__PURE__*/_react.default.createElement(_MessageInput.default, null)), /*#__PURE__*/_react.default.createElement(_streamChatReact.Thread, {
    Message: _Message.default,
    additionalMessageInputProps: {
      Input: _MessageInputInner.default
    }
  }), hasAnyTypeOfBan && /*#__PURE__*/_react.default.createElement(_YouAreBannedNotification.default, {
    channelBan: channelBan
    // legacy global ban property, still here to make sure any members banned earlier this way are still blocked
    ,
    globalBan: globalBan,
    publicChatBan: publicChatBan
  }), isNotInCommunityChannel && !hasAnyTypeOfBan && /*#__PURE__*/_react.default.createElement(_JoinChannel.default, {
    channel: channelId,
    joinChat: function joinChat() {
      _joinChat(channelId);
    },
    joiningChat: joiningChat
  })));
};
var _default = Channel;
exports.default = _default;